import { api } from "@/api";
import { ApiResponseType, PostEmailVerificationResponse } from "@/api/type";

interface postEmailVerificationProps {
    emailAddress: string;
}

export const postEmailVerification = async({emailAddress}: postEmailVerificationProps) => {
    try {
        const res = await api.post<ApiResponseType<PostEmailVerificationResponse>>(`/api/web/visitors/verification-requests`, {
            emailAddress: emailAddress,
        })
        return res.data;
    } catch (err) {
        console.error("postEmailVerification API error:", err)
        throw err;
    }
}